// extracted by mini-css-extract-plugin
module.exports = {"circle":"cloud_circle__DcsDw","gasfee":"cloud_gasfee__vwhmJ","btnContainer":"cloud_btnContainer__ry_xq","button":"cloud_button__LMUvx","slippageWarn":"cloud_slippageWarn__oaIa5"};